import React from 'react'
import { Form } from 'semantic-ui-react'

const AttendanceTypeFilter = ({ value, onChange, ...remainingProps }) => {
  const attendTypeOptions = [{value:'NEW',text:'Nová'},{value:'PREV',text:'Připravená'},{value:'SHOW',text:'Aktivní'},{value:'SEND',text:'Odeslaná'},{value:'OK',text:'Platná'},{value:'ARCH',text:'Blokovaná'}]
  if (!remainingProps.multiple) attendTypeOptions.unshift({ value: '', text: 'Vše' })
  let realValue = value
  if (!realValue && remainingProps.multiple) realValue = []
  return (
    <Form.Select
      options={attendTypeOptions}
      value={realValue}
      onChange={(e, value) => onChange(value)}
      {...remainingProps}
    />
  )
}

AttendanceTypeFilter.defaultProps = {
  multiple: false,
  value: '',
}

AttendanceTypeFilter.propTypes = {
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default AttendanceTypeFilter



// WEBPACK FOOTER //
// ./src/browser/components/filters/AttendanceTypeFilter.js